export const inputArrows = () => {
    const arrowElems = document.querySelectorAll('#plans-prices .calc__param-input-wrapper');

    const setWidth = (e) => {
        const input = e.currentTarget || e;
        const length = input.value.toString().length;
        const newWidth = length * 8 + 'px';
        if (length > 2) {
            input.style.width = length * 10.5 + 'px';
        } else {
            input.style.width = '38px';
        }
    }

    arrowElems.forEach(parent => {
        const calcForm = document.querySelector('#plans-prices #calculator');
        const increaseBtn = parent.firstElementChild;
        const derceaseBtn = parent.lastElementChild;
        const input = document.querySelector(`#plans-prices input[name="${parent.dataset.for}"]`);
        input.addEventListener('input', setWidth);

        const changeValue = (e) => {
            if (e.currentTarget.classList[0].includes('increase')) {
                input.value = Math.round(+input.value + 1)
            } else if ( +input.value - 1 >= 0) {
                input.value = Math.round(+input.value - 1)
            }
            calcForm.dispatchEvent(new Event('change'));
            input.dispatchEvent(new Event('input'));
        };

        increaseBtn.addEventListener('click', changeValue);
        derceaseBtn.addEventListener('click', changeValue);
    });
};